import styles from './app.module.scss'
import classNames from 'classnames'
import { useEffect} from 'react'
import { Label } from './components/views/Label/Label'
import { ChatWindows } from './components/ui/chat-windows/ChatWindows'
import { useRedux } from './components/hooks/useRedux'
import { OPEN_CLOSE_CHAT} from './redux/types'
import {Header} from './components/views/commun/header/Header'
//import { getColor } from './assets/Js/modules/styles/styles.module'
import { Footer } from './components/views/commun/footer/Footer'
import { Body } from './components/views/commun/body/Body'
import { DepartmentsList } from './components/lists/departments/departmentsList/DepartmentsList'
import { useStorage } from './components/hooks/useStorage'
import { useMessage } from './components/hooks/messages/useMessage'
import { Context } from './Context'
import { useSelector } from 'react-redux'
import { Dialogs } from './components/lists/dialogs/Dialogs'
import { DialogMessages } from './components/lists/dialogs/DialogMessages'



const App = () => {
  const { REDUCER_DISPASH} = useRedux()
  const isOpenChat = useSelector(state => state.defaultReducer?.chatIsOpen??false)//REDUCER_STATE?.defaultReducer?.chatIsOpen??false
  const variablesReducer = useSelector(state => state.variablesReducer??false)//REDUCER_STATE?.variablesReducer?.openDepartments??false
  const {InitStorage, StorageListerner} = useStorage()
  const useMessageHook = useMessage()
  
  const openDepartments = variablesReducer?.openDepartments
  const activeView = variablesReducer?.activeView

  console.warn('App-component', variablesReducer)
  //===>> APP INIT
  useEffect(() => {
    
    //===>>> Default close chat window
    addEventListener('click', (e) => {
      const elem = e.target
      //console.log('useMessageHook', useMessageHook)
      if((!(elem?.dataset?.name==='chat-window')&&!elem?.closest('[data-name="chat-label"]'))&&!elem?.closest('[data-name="chat-window"]')) {
        if((elem?.dataset?.closeW==='false')||elem?.closest('[data-close-w="false"]')) return
        REDUCER_DISPASH({type: OPEN_CLOSE_CHAT, payload:false})
      } else
      if((elem?.dataset?.closeW==='true')||elem?.closest('[data-close-w="true"]')) REDUCER_DISPASH({type: OPEN_CLOSE_CHAT, payload:true})
    })

    //===>>>
    InitStorage()
    StorageListerner()

    return () => StorageListerner
  }, [])


  const bodyActiveView = openDepartments&&<DepartmentsList/>
  let VIEW
  switch (activeView) {
    case 'CHAT':
      VIEW = <>
       <Header/>
       <Body activeView={bodyActiveView}/>
       <Footer/>
      </>
      break
    case 'DEPARTMENTS_LIST':
      VIEW = <>
        <Header />
        <DepartmentsList/>
      </>
      break

    case 'DIALOGS_LIST':
      VIEW = <>
        <Header config={{showMenu:false, showConsultant:false}}/>
        <Dialogs/>
      </>
      break
    case 'SELECTED_DIALOG':
      VIEW = <>
        <Header config={{showMenu:false, showConsultant:false}}/>
        <DialogMessages/>
        <Footer typeDialog="group"/>
      </>
      break
  }
  

  return (
    <Context.Provider value={{useMessageHook}}>
      <div className={classNames(styles.app)}>
        <Label />
        <ChatWindows open={isOpenChat} >
          {VIEW}
        </ChatWindows>
      </div>
    </Context.Provider>
  )
}
export default App
